
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/dunning-prompt-settings",
      function () {
        return require("private-next-pages/admin/dunning-prompt-settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/dunning-prompt-settings"])
      });
    }
  